import FinishTimecardIconButton from 'pages/timecards/buttons/FinishTimecardIconButton';
import TimecardTrackingButton from 'pages/timecards/buttons/TimecardTrackingButton';
import { useSelector } from 'store';
import { TimecardDetails } from 'types/timecards';

type Props = {
    timecard: TimecardDetails;
};

export default function TrackingWidgetControls({ timecard }: Props) {
    const duration = useSelector((state) => state.timecard.timecardDuration);

    return (
        <div className="bg-grey-200 flex items-center justify-between rounded-[34px] px-1 py-[5px]">
            <TimecardTrackingButton timecard={timecard} />
            <span>{duration}</span>
            <FinishTimecardIconButton timecard={timecard} />
        </div>
    );
}
